/* eslint-disable import/no-anonymous-default-export */
import { SET_ADVANCE_SCROLL } from '../actionConstants';

export default (state = '', action) => {
  switch (action.type) {
    case SET_ADVANCE_SCROLL:
      return action.payload;
    default:
      return state;
  }
};
